// src/app/utilities/session.ts
import Cookies from 'js-cookie';

const SESSION_KEY = 'cj_session_id';

export function getSessionId(): string {
    let sessionId = Cookies.get(SESSION_KEY);
    if (!sessionId) {
        sessionId = generateSessionId();
        Cookies.set(SESSION_KEY, sessionId, { expires: 7, path: '/' });
    }
    return sessionId;
}

function generateSessionId(): string {
    // Simple random string, you can use uuid if preferred
    return (
        Date.now().toString(36) + '-' + Math.random().toString(36).substr(2, 9)
    );
}
